import type { SVGProps } from "react";
import * as React from "react";

const SvgEyeOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#eye-off_svg__a)">
      <path
        fill="currentColor"
        d="m17.94 17.94.606.795a1 1 0 0 0 .101-1.502zM12 20v1h.016zM1 12l-.881-.473a1 1 0 0 0-.013.92zm5.06-5.94.707-.707a1 1 0 0 0-1.314-.088zm3.612-2.794a1 1 0 0 0 .456 1.948zM12 4l-.002 1H12zm11 8 .882.471a1 1 0 0 0 .012-.918zm-2.925 2.546a1 1 0 0 0 1.53 1.288zm-5.223.256a1 1 0 1 0-1.464-1.364zm-4.29-4.19a1 1 0 1 0-1.364-1.464zM1.707.292A1 1 0 0 0 .293 1.708zm20.586 23.415a1 1 0 0 0 1.414-1.414zm-4.96-6.562A9.07 9.07 0 0 1 11.984 19l.033 2a11.07 11.07 0 0 0 6.53-2.265zM12 19c-3.1 0-5.604-1.774-7.395-3.684a18.7 18.7 0 0 1-2.548-3.463 10 10 0 0 1-.156-.287l-.006-.012-.001-.002L1 12l-.894.448q0 .002.002.003l.014.03a8 8 0 0 0 .192.353 20.67 20.67 0 0 0 2.831 3.85C5.105 18.774 8.1 21 12 21zM1.881 12.473a17.45 17.45 0 0 1 4.786-5.618l-1.214-1.59A19.45 19.45 0 0 0 .12 11.527zm3.472-5.706 11.88 11.88 1.414-1.414-11.88-11.88zm4.775-1.553A8 8 0 0 1 11.998 5l.004-2a10 10 0 0 0-2.33.266zM12 5c3.1 0 5.605 1.774 7.395 3.684a18.7 18.7 0 0 1 2.548 3.463q.086.153.127.23l.029.057.006.012.001.002L23 12l.894-.448q0-.002-.002-.003l-.003-.007-.011-.022a11 11 0 0 0-.192-.354 20.675 20.675 0 0 0-2.831-3.85C18.895 5.226 15.899 3 12 3zm10.118 6.529a17.5 17.5 0 0 1-2.043 3.017l1.53 1.288a19.5 19.5 0 0 0 2.277-3.363zm-8.73 1.91a2 2 0 0 1-.649.463l.814 1.827c.49-.22.932-.534 1.299-.927zm-.649.463a2 2 0 0 1-.779.173l.036 2a4 4 0 0 0 1.557-.346zm-.779.173a2 2 0 0 1-.784-.146l-.749 1.855a4 4 0 0 0 1.569.29zm-.784-.146c-.249-.1-.475-.25-.665-.44l-1.414 1.414a4 4 0 0 0 1.33.88zm-.665-.44c-.19-.19-.34-.416-.44-.665l-1.855.749a4 4 0 0 0 .88 1.33zm-.44-.665a2 2 0 0 1-.146-.784l-2-.036a4 4 0 0 0 .291 1.569zm-.146-.784a2 2 0 0 1 .173-.78l-1.827-.813a4 4 0 0 0-.345 1.557zm.173-.78a2 2 0 0 1 .464-.648L9.198 9.148a4 4 0 0 0-.927 1.299zM.293 1.708l22 22 1.414-1.414-22-22z"
      />
    </g>
    <defs>
      <clipPath id="eye-off_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEyeOff;
